// UI visibility only. The API independently enforces the named-admin policy.
// Older QA login responses predate both capability flags but include email.
const ADMIN_EMAILS = new Set([
  "sl@royalkosher.net",
  "yanky@royalkosher.net",
  "bk@royalkosher.net",
  "andersondenise@example.org",
]);

export function canManagePeriodicTasks(user) {
  if (!user) return false;
  if (typeof user.can_manage_periodic_tasks === "boolean") {
    return user.can_manage_periodic_tasks;
  }
  if (typeof user.can_delete_accounts === "boolean") {
    return user.can_delete_accounts;
  }
  return ADMIN_EMAILS.has((user.email || "").trim().toLowerCase());
}
